
import store from '@/store';
import { noop } from '../util';
import { loadHbridge } from '../globalLoader';
import { getVersion } from '../version';

let inited = false;

async function init(UBT) {
  if (inited) return;
  inited = true;
  const CODE_ENV = process.env.VUE_APP_ENV;

  // 如果首次加载页面是 /one-yuan-welfare-card/buy 页面，则埋点设置为立即上报
  const isOneYuanWelfareCardBuy = window.location.hash.startsWith('#/one-yuan-welfare-card/buy');

  UBT.config({
    env: CODE_ENV,
    debug: CODE_ENV !== 'pro',
    categoryId: 'switchpower',
    useBridge: false,
    logMaxCount: isOneYuanWelfareCardBuy ? 1 : 10,
    logTimeout: isOneYuanWelfareCardBuy ? 1000 : 30 * 1000,
  });

  const getSystemInfo = async () => {
    const { env } = await loadHbridge();
    let systemCode = 'A5';
    let platform = 'Alipay';
    if (env.isEasyBikeApp) {
      // 哈啰出行 APP
      const { os } = env.platform;
      if (os === 'Android') {
        systemCode = '62';
        platform = 'Android';
      } else if (os === 'IOS') {
        systemCode = '61';
        platform = 'iOS';
      }
    }
    return {
      systemCode,
      platform,
    };
  };

  async function bindData() {
    const { env, Native } = await loadHbridge();
    const task = [
      getVersion(),
      getSystemInfo(),
    ];
    if (!window.__PRERENDER_INJECTED) {
      task.push(
        // 获取城市
        store.dispatch('location/getLocation').catch(noop),
        // 获取用户信息
        store.dispatch('user/getUserInfo').catch(noop),
      );

      if (env.isAliMP || env.isAliMPMonitor || env.isEasyBikeApp) {
        task.push(
          Native.getSSID().then((r) => {
            let ssid = '';
            if (typeof r === 'string') {
              ssid = r;
            } else {
              ssid = r.ssid;
            }
            if (ssid && typeof ssid === 'string') UBT.bindData({ ssid });
          }),
        );
      }
    }
    const [version, sysInfo] = await Promise.all(task);
    const opt = {
      appVersion: version,
      releaseVersion: version,
      appName: 'AppHelloPowerH5',
      userGuid: () => store.state.user.platformUserGuid,
      cityCode: () => store.state.location.cityCode || '',
      cityName: () => store.state.location.cityName || '',
      adCode: () => store.state.location.adCode || '',
      longitude: () => store.state.location.longitude || '',
      latitude: () => store.state.location.latitude || '',
      ...sysInfo,
    };
    UBT.bindData(opt);
  }

  await bindData();
}

async function loadUBT() {
  const { env, Native } = await loadHbridge();
  const UBT = await import(/* webpackChunkName:"npm/@hb/tianqi/lib/ubt.h5" */'@hb/tianqi/lib/ubt.h5').then((r) => r.UBT);
  await init(UBT);

  if (process.env.VUE_APP_ENV !== 'pro') {
    if (env.isAliMP || env.isAliMPMonitor) {
      const { verifyUrl } = await Native.callNative({
        classMap: 'SwitchBridge',
        method: 'getSwitchCache',
        timeout: false,
      });
      if (verifyUrl) {
        UBT.verify(verifyUrl);
      }
    } else if (env.isEasyBikeApp) {
      const { default: ELF } = await import('@hb/elf');

      const elf = new ELF({
        envConfig: ['dev', 'fat', 'uat'],
        tianQiUbtInstance: UBT,
        // 非必需，若为空则默认从localStorage中获取上一次选择的环境
        currentEnv: process.env.VUE_APP_ENV,
      });


      elf
        .on('envChanged', (event) => {
          // eslint-disable-next-line no-console
          console.log(event.data); // dev, fat, fat_2, uat
        })
        .on('load', () => {
          // load事件在envChanged之后触发
          // 可以用于项目实例的初始化，避免请求先于envChanged事件发出的问题
          // new Vue({ el: '#app' });
        }).on('startVerifyUbt', async (event) => {
          // 调用容器的扫码方法扫描二维码
          Native.scanQRCode().then((res) => {
            const verifyUbt = event.data;
            let { result } = res;
            if (result && result.indexOf('"url":') === -1) {
              result = JSON.stringify({
                url: result,
              });
            }
            verifyUbt(result);
          });
        });
    }
  }
  return UBT;
}

class IUBT {
  UBT = null

  async config(...args) {
    if (!this.UBT) {
      this.UBT = await loadUBT();
    }

    return this.UBT.config(...args);
  }

  async pageView(...args) {
    if (!this.UBT) {
      this.UBT = await loadUBT();
    }

    return this.UBT.pageView(...args);
  }

  async pageViewOut(...args) {
    if (!this.UBT) {
      this.UBT = await loadUBT();
    }

    return this.UBT.pageViewOut(...args);
  }

  async clickButton(...args) {
    if (!this.UBT) {
      this.UBT = await loadUBT();
    }

    return this.UBT.clickButton(...args);
  }

  async customEventWithPointId(...args) {
    if (!this.UBT) {
      this.UBT = await loadUBT();
    }

    return this.UBT.customEventWithPointId(...args);
  }

  async moduleExpose(...args) {
    if (!this.UBT) {
      this.UBT = await loadUBT();
    }
    return this.UBT.moduleExpose(...args);
  }
}

export default new IUBT();
